import { render, staticRenderFns } from "./ErrorBlock.vue?vue&type=template&id=c57b936c&"
import script from "./ErrorBlock.vue?vue&type=script&lang=js&"
export * from "./ErrorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports